
import Clarity from "@microsoft/clarity";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import AuthIllustration from "../common/AuthIllustration";
import AuthShell from "../common/AuthShell";
import Form from "./Form";

export default function Verify() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(window.innerWidth > 768);
	const [phoneNumber, setPhoneNumber] = useState("");
	const hasInitialized = useRef(false);
	const location = useLocation();

	useEffect(() => {
		if (!hasInitialized.current) {
			hasInitialized.current = true;
			const params = new URLSearchParams(location.search);
			setPhoneNumber(params.get("phone_number") || "");
		}
	}, [location.search]);

	return (
		<>
			<Helmet>
				<title>ورود | تأیید شماره | همراهتیم</title>
				<meta name="description" content="تایید شماره همراه به همراهتیم" />
			</Helmet>

			<AuthShell isDesktop={isDesktop}>
				<AuthIllustration />
				<Form phoneNumber={phoneNumber} />
			</AuthShell>
		</>
	);
}
